import React, { useEffect, useState } from 'react'
import Header from '../components/Header/Header'
import ChatPanel from '../customComponents/ChatPanel/ChatPanel'
import { fetchData } from '../store/actions/thunk_actions'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../store/reducers/store'
import { useTranslation } from 'react-i18next'
import Footer from '../components/Footer/Footer'
import MainLoader from '../customComponents/InfiniteLoader/MainLoader'

const fallbackPalette = {
    primary: '#133371',
}

const HomePage: React.FC = () => {
    const { i18n } = useTranslation()
    const data = useAppSelector((data) => data.data)
    const graphic = useAppSelector((data) => data.graphic)
    const dispatch = useAppDispatch()
    const [queryParams] = useSearchParams()
    const [animatedHeader, setAnimatedHeader] = useState(data.currentInstance?.keys?.graphics.animated_header || false)

    useEffect(() => {
        setAnimatedHeader(data.currentInstance?.keys?.graphics.animated_header ?? false)
        document.documentElement.style.setProperty(
            '--primary-color',
            data.currentInstance?.keys?.graphics.palette.primary || fallbackPalette.primary
        )
    }, [data.currentInstance])

    useEffect(() => {
        const idInstance = queryParams.get('instance')
        const language = queryParams.get('lang')
        if (language) {
            void i18n.changeLanguage(language)
        }

        if (!idInstance) return
        void dispatch(fetchData(idInstance))
    }, [])

    return (
        <div>
            {graphic.fetchingInfoLoaderIsShown && <MainLoader />}
            {/* <Sidebar /> */}
            <Header title={data.currentInstance?.name || ''} />
            <div className="main-chat-container" style={{ marginTop: animatedHeader ? '' : '10vh' }}>
                <ChatPanel />
            </div>
            <Footer />
        </div>
    )
}

export default HomePage
